module.exports = __webpack_public_path__ + "img/zhuce.abc78cee.png";